import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import "./Booking.css";

const mockTables = [
  // Khu vực chung
  {
    id: "T01",
    name: "Bàn 01",
    seats: 2,
    status: "available",
    area: "General",
    type: "Sofa đôi",
    features: ["Gần cửa sổ", "Ổ cắm điện"],
    price: 30000,
    position: { x: 20, y: 20 },
  },
  {
    id: "T02",
    name: "Bàn 02",
    seats: 2,
    status: "occupied",
    area: "General",
    type: "Bàn cao",
    features: ["View phố"],
    price: 25000,
    position: { x: 60, y: 20 },
  },
  {
    id: "T03",
    name: "Bàn 03",
    seats: 4,
    status: "available",
    area: "General",
    type: "Bàn nhóm",
    features: ["Bảng trắng", "Ổ cắm rộng"],
    price: 50000,
    position: { x: 20, y: 60 },
  },
  {
    id: "T04",
    name: "Bàn 04",
    seats: 4,
    status: "available",
    area: "General",
    type: "Bàn tròn",
    features: ["Yên tĩnh"],
    price: 45000,
    position: { x: 60, y: 60 },
  },
  // Khu vực yên tĩnh
  {
    id: "Q01",
    name: "Quiet 1",
    seats: 1,
    status: "available",
    area: "Quiet Zone",
    type: "Ghế ergonomic",
    features: ["Đèn đọc sách", "Cách âm"],
    price: 60000,
    position: { x: 15, y: 25 },
  },
  {
    id: "Q02",
    name: "Quiet 2",
    seats: 1,
    status: "available",
    area: "Quiet Zone",
    type: "Cabin riêng",
    features: ["Màn hình phụ", "Tai nghe"],
    price: 80000,
    position: { x: 50, y: 25 },
  },
  {
    id: "Q03",
    name: "Quiet 3",
    seats: 1,
    status: "occupied",
    area: "Quiet Zone",
    type: "Booth riêng",
    features: ["Cách âm cao cấp"],
    price: 90000,
    position: { x: 85, y: 25 },
  },
  // Phòng họp
  {
    id: "M01",
    name: "Meeting A",
    seats: 6,
    status: "reserved",
    area: "Meeting Room",
    type: "Phòng kín",
    features: ["Máy chiếu", "TV 4K", "Loa hội nghị"],
    price: 200000,
    position: { x: 25, y: 35 },
  },
  {
    id: "M02",
    name: "Meeting B",
    seats: 10,
    status: "available",
    area: "Meeting Room",
    type: "Hội trường nhỏ",
    features: ["Bảng kính", "Webcam 4K"],
    price: 300000,
    position: { x: 70, y: 35 },
  },
];

function Booking() {
  const [step, setStep] = useState(1);
  const [selectedArea, setSelectedArea] = useState("all");
  const [selectedTable, setSelectedTable] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedTableDetails, setSelectedTableDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const [bookingData, setBookingData] = useState({
    date: "",
    startTime: "",
    duration: 2,
    guests: 1,
    tableId: "",
    customerName: localStorage.getItem("userName") || "",
    customerPhone: "",
    note: "",
  });

  // Get min date (today)
  const getMinDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  // Validate step 1
  const validateStep1 = () => {
    const newErrors = {};
    if (!bookingData.date) newErrors.date = "Vui lòng chọn ngày";
    if (!bookingData.startTime) newErrors.startTime = "Vui lòng chọn giờ";

    // Check if selected time is in the past
    if (bookingData.date && bookingData.startTime) {
      const selectedDateTime = new Date(
        `${bookingData.date}T${bookingData.startTime}`
      );
      if (selectedDateTime < new Date()) {
        newErrors.startTime = "Không thể đặt chỗ trong quá khứ";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validate step 3
  const validateStep3 = () => {
    const newErrors = {};
    if (!bookingData.customerName.trim()) {
      newErrors.customerName = "Vui lòng nhập họ tên";
    }
    if (!bookingData.customerPhone.trim()) {
      newErrors.customerPhone = "Vui lòng nhập số điện thoại";
    } else if (
      !/^[0-9]{10}$/.test(bookingData.customerPhone.replace(/\s/g, ""))
    ) {
      newErrors.customerPhone = "Số điện thoại không hợp lệ (10 chữ số)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (step === 1 && !validateStep1()) {
      return;
    }
    if (step === 2 && !bookingData.tableId) {
      setErrors({ tableId: "Vui lòng chọn bàn!" });
      return;
    }
    setErrors({});
    setStep(step + 1);
  };

  const handleBack = () => {
    setErrors({});
    setStep(step - 1);
  };

  const handleTableSelect = (table) => {
    if (table.status !== "available") return;
    setBookingData({ ...bookingData, tableId: table.id });
    setSelectedTableDetails(table);
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep3()) {
      return;
    }

    setIsSubmitting(true);

    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setShowSuccess(true);

      // Auto close success message after 3 seconds
      setTimeout(() => {
        setShowSuccess(false);
        // Reset form or redirect
        window.location.href = "/";
      }, 3000);
    }, 1500);
  };

  // Render Steps
  const renderStep1 = () => (
    <Card className="shadow-sm border-0 rounded-4 p-4 mb-4">
      <h4 className="mb-4 fw-bold">
        <i className="bi bi-calendar-check me-2 text-primary"></i>
        Thông tin thời gian
      </h4>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Ngày đặt <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              required
              min={getMinDate()}
              value={bookingData.date}
              isInvalid={!!errors.date}
              onChange={(e) => {
                setBookingData({ ...bookingData, date: e.target.value });
                setErrors({ ...errors, date: null });
              }}
              className="rounded-3"
            />
            <Form.Control.Feedback type="invalid">
              {errors.date}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Giờ bắt đầu <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="time"
              required
              value={bookingData.startTime}
              isInvalid={!!errors.startTime}
              onChange={(e) => {
                setBookingData({ ...bookingData, startTime: e.target.value });
                setErrors({ ...errors, startTime: null });
              }}
              className="rounded-3"
            />
            <Form.Control.Feedback type="invalid">
              {errors.startTime}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Thời lượng (giờ)</Form.Label>
            <Form.Select
              value={bookingData.duration}
              onChange={(e) =>
                setBookingData({ ...bookingData, duration: e.target.value })
              }
              className="rounded-3"
            >
              <option value="1">1 Giờ</option>
              <option value="2">2 Giờ</option>
              <option value="4">4 Giờ</option>
              <option value="8">Cả ngày (8h)</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Số lượng khách</Form.Label>
            <Form.Control
              type="number"
              min="1"
              max="20"
              value={bookingData.guests}
              onChange={(e) =>
                setBookingData({ ...bookingData, guests: e.target.value })
              }
              className="rounded-3"
            />
            <Form.Text className="text-muted">
              <i className="bi bi-info-circle me-1"></i>
              Tối đa 20 người
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    </Card>
  );

  const renderStep2 = () => {
    // Group tables by area
    const generalTables = mockTables.filter((t) => t.area === "General");
    const quietTables = mockTables.filter((t) => t.area === "Quiet Zone");
    const meetingTables = mockTables.filter((t) => t.area === "Meeting Room");

    return (
      <div className="mb-4">
        <h4 className="mb-4 text-center fw-bold">
          <i className="bi bi-grid-3x3-gap me-2 text-primary"></i>
          Chọn vị trí ngồi
        </h4>

        {errors.tableId && (
          <div
            className="alert alert-danger d-flex align-items-center mb-3"
            role="alert"
          >
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {errors.tableId}
          </div>
        )}

        <Row>
          <Col md={8}>
            {/* Legend */}
            <div className="d-flex justify-content-center gap-4 mb-3 p-3 bg-light rounded-3">
              <span className="d-flex align-items-center">
                <div
                  className="rounded-circle bg-white border border-success me-2"
                  style={{ width: 16, height: 16 }}
                ></div>
                <small className="fw-medium">Còn trống</small>
              </span>
              <span className="d-flex align-items-center">
                <div
                  className="rounded-circle bg-light border border-danger me-2"
                  style={{ width: 16, height: 16 }}
                ></div>
                <small className="fw-medium">Đã đặt/Bận</small>
              </span>
              <span className="d-flex align-items-center">
                <div
                  className="rounded-circle border-2 border border-success me-2"
                  style={{
                    width: 16,
                    height: 16,
                    background: "rgba(40, 199, 111, 0.15)",
                  }}
                ></div>
                <small className="fw-medium">Đang chọn</small>
              </span>
            </div>

            <div className="p-4 bg-white rounded-4 shadow-sm">
              <div className="fw-bold text-primary mb-3 d-flex align-items-center">
                <i className="bi bi-house-door me-2"></i>
                Khu vực chung
                <span className="badge bg-primary ms-auto">
                  {generalTables.filter((t) => t.status === "available").length}
                  /{generalTables.length} trống
                </span>
              </div>
              <div className="d-flex flex-wrap gap-3 mb-4">
                {generalTables.map((table) => renderTableBox(table))}
              </div>

              <div className="fw-bold text-primary mb-3 mt-4 d-flex align-items-center">
                <i className="bi bi-volume-mute me-2"></i>
                Quiet Zone
                <span className="badge bg-primary ms-auto">
                  {quietTables.filter((t) => t.status === "available").length}/
                  {quietTables.length} trống
                </span>
              </div>
              <div className="d-flex flex-wrap gap-3 mb-4">
                {quietTables.map((table) => renderTableBox(table))}
              </div>

              <div className="fw-bold text-primary mb-3 mt-4 d-flex align-items-center">
                <i className="bi bi-people me-2"></i>
                Phòng họp
                <span className="badge bg-primary ms-auto">
                  {meetingTables.filter((t) => t.status === "available").length}
                  /{meetingTables.length} trống
                </span>
              </div>
              <div className="d-flex flex-wrap gap-3">
                {meetingTables.map((table) => renderTableBox(table))}
              </div>
            </div>
          </Col>
          <Col md={4}>
            {/* Detailed List Side Panel */}
            <Card
              className="h-100 shadow-sm border-0 sticky-top"
              style={{ top: "100px" }}
            >
              <Card.Header className="bg-white fw-bold py-3 border-bottom">
                <i className="bi bi-info-circle me-2 text-primary"></i>Chi tiết
                bàn
              </Card.Header>
              <Card.Body
                className="overflow-auto"
                style={{ maxHeight: "500px" }}
              >
                {selectedTableDetails ? (
                  <div className="fade-in-animation">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="text-success mb-0">
                        {selectedTableDetails.name}
                      </h4>
                      <span className="badge bg-primary">
                        {selectedTableDetails.area}
                      </span>
                    </div>
                    <div className="mb-3">
                      <label className="text-muted small">Loại bàn:</label>
                      <div className="fw-bold">{selectedTableDetails.type}</div>
                    </div>
                    <div className="mb-3">
                      <label className="text-muted small">Sức chứa:</label>
                      <div className="fw-bold">
                        <i className="bi bi-people me-2"></i>
                        {selectedTableDetails.seats} người
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="text-muted small">Tiện ích:</label>
                      <ul className="list-unstyled mt-1">
                        {selectedTableDetails.features.map((f, i) => (
                          <li key={i} className="mb-1">
                            <i className="bi bi-check-circle-fill text-success me-2 small"></i>
                            {f}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <hr />
                    <div className="text-end">
                      <small className="text-muted d-block">Giá / giờ</small>
                      <span className="fs-4 fw-bold text-primary">
                        {new Intl.NumberFormat("vi-VN", {
                          style: "currency",
                          currency: "VND",
                        }).format(selectedTableDetails.price)}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-muted py-5">
                    <i className="bi bi-arrow-left display-4 mb-3 d-block opacity-50"></i>
                    <p>
                      Vui lòng chọn một bàn bên trái để xem thông tin chi tiết
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };

  const renderTableBox = (table) => {
    const isSelected = bookingData.tableId === table.id;
    const isAvailable = table.status === "available";

    return (
      <div
        key={table.id}
        className={`p-3 rounded-3 border text-center position-relative ${
          isAvailable ? "" : "opacity-50"
        }`}
        style={{
          width: "130px",
          cursor: isAvailable ? "pointer" : "not-allowed",
          background: isSelected
            ? "rgba(40, 199, 111, 0.15)"
            : isAvailable
            ? "white"
            : "#f8f9fa",
          borderColor: isSelected
            ? "#28c76f"
            : isAvailable
            ? "#dee2e6"
            : "#dc3545",
          borderWidth: isSelected ? "2px" : "1px",
          transition: "all 0.2s ease-in-out",
        }}
        onClick={() => handleTableSelect(table)}
        onMouseEnter={(e) => {
          if (isAvailable && !isSelected) {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.12)";
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
        role="button"
        tabIndex={isAvailable ? 0 : -1}
        aria-label={`${table.name}, ${table.seats} chỗ ngồi, ${
          isAvailable ? "còn trống" : "đã đặt"
        }`}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleTableSelect(table);
          }
        }}
      >
        {isSelected && (
          <div className="position-absolute top-0 end-0 m-1">
            <i className="bi bi-check-circle-fill text-success"></i>
          </div>
        )}
        <i
          className={`bi ${
            table.area === "Meeting Room" ? "bi-people-fill" : "bi-display"
          } fs-4 d-block mb-2`}
          style={{
            color: isSelected ? "#28c76f" : isAvailable ? "#6c757d" : "#dc3545",
          }}
        ></i>
        <span className="fw-bold d-block small mb-1">{table.name}</span>
        <small className="text-muted d-block">
          <i className="bi bi-people me-1"></i>
          {table.seats} chỗ
        </small>
        {!isAvailable && (
          <span className="badge bg-danger mt-2 small">
            {table.status === "occupied" ? "Đang dùng" : "Đã đặt"}
          </span>
        )}
      </div>
    );
  };

  const renderStep3 = () => (
    <Row>
      <Col md={7}>
        <Card className="shadow-sm border-0 rounded-4 p-4 mb-4">
          <h4 className="mb-3 fw-bold">
            <i className="bi bi-person-lines-fill me-2 text-primary"></i>
            Thông tin liên hệ
          </h4>
          <Form onSubmit={handleSubmit} id="bookingForm">
            <Form.Group className="mb-3">
              <Form.Label>
                Họ và tên <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Nhập tên của bạn"
                required
                value={bookingData.customerName}
                isInvalid={!!errors.customerName}
                onChange={(e) => {
                  setBookingData({
                    ...bookingData,
                    customerName: e.target.value,
                  });
                  setErrors({ ...errors, customerName: null });
                }}
                className="rounded-3"
                autoComplete="name"
              />
              <Form.Control.Feedback type="invalid">
                {errors.customerName}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                Số điện thoại <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="tel"
                placeholder="09xxxxxxxx"
                required
                value={bookingData.customerPhone}
                isInvalid={!!errors.customerPhone}
                onChange={(e) => {
                  setBookingData({
                    ...bookingData,
                    customerPhone: e.target.value,
                  });
                  setErrors({ ...errors, customerPhone: null });
                }}
                className="rounded-3"
                autoComplete="tel"
                inputMode="numeric"
              />
              <Form.Control.Feedback type="invalid">
                {errors.customerPhone}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Ghi chú thêm</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Yêu cầu đặc biệt (không bắt buộc)"
                value={bookingData.note}
                onChange={(e) =>
                  setBookingData({ ...bookingData, note: e.target.value })
                }
                className="rounded-3"
              />
            </Form.Group>
          </Form>
        </Card>
      </Col>
      <Col md={5}>
        <Card
          className="border-0 rounded-4 p-4 shadow-sm sticky-top"
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            top: "100px",
          }}
        >
          <h5 className="mb-3 fw-bold">
            <i className="bi bi-card-checklist me-2"></i>
            Tóm tắt đặt chỗ
          </h5>
          <hr className="border-white opacity-50" />
          <div className="d-flex justify-content-between mb-2">
            <span className="opacity-75">
              <i className="bi bi-calendar3 me-2"></i>
              Ngày:
            </span>
            <strong>{bookingData.date || "--/--/----"}</strong>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="opacity-75">
              <i className="bi bi-clock me-2"></i>
              Giờ:
            </span>
            <strong>
              {bookingData.startTime || "--:--"} ({bookingData.duration}h)
            </strong>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="opacity-75">
              <i className="bi bi-geo-alt me-2"></i>
              Vị trí:
            </span>
            <strong>
              {mockTables.find((t) => t.id === bookingData.tableId)?.name ||
                "Chưa chọn"}
            </strong>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="opacity-75">
              <i className="bi bi-people me-2"></i>
              Số khách:
            </span>
            <strong>{bookingData.guests} người</strong>
          </div>
          <hr className="border-white opacity-50" />
          <div className="d-flex justify-content-between align-items-center mt-3">
            <span className="fs-6">Tổng tiền (dự kiến):</span>
            <span className="fs-4 fw-bold">
              {new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND",
              }).format(
                bookingData.duration *
                  (mockTables.find((t) => t.id === bookingData.tableId)
                    ?.price || 50000)
              )}
            </span>
          </div>
          <div className="mt-3">
            <small className="opacity-75">
              <i className="bi bi-info-circle me-1"></i>
              Giá cuối cùng có thể thay đổi tùy dịch vụ
            </small>
          </div>
        </Card>
      </Col>
    </Row>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)",
        paddingBottom: "60px",
      }}
    >
      <div
        className="text-center py-5 mb-4"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#fff",
        }}
      >
        <Container>
          <h1 className="fw-bold mb-3">Đặt Bàn Trước</h1>
          <p className="opacity-75 fs-5">
            Giữ chỗ ngay để có không gian làm việc tốt nhất
          </p>
        </Container>
      </div>

      <Container className="pb-5" style={{ maxWidth: "900px" }}>
        {/* Step Wizard UI */}
        <div className="d-flex align-items-center justify-content-center mb-5">
          <div
            className={`d-flex flex-column align-items-center ${
              step >= 1 ? "text-primary" : "text-muted"
            }`}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center mb-2 fw-bold"
              style={{
                width: "50px",
                height: "50px",
                background:
                  step >= 1
                    ? "linear-gradient(135deg, #667eea, #764ba2)"
                    : "#e9ecef",
                color: step >= 1 ? "white" : "#6c757d",
                fontSize: "1.2rem",
              }}
            >
              {step > 1 ? <i className="bi bi-check-lg"></i> : "1"}
            </div>
            <span className="small fw-semibold">Thời gian</span>
          </div>
          <div
            style={{
              width: "80px",
              height: "2px",
              background: step >= 2 ? "#667eea" : "#dee2e6",
              margin: "0 10px 30px",
            }}
          ></div>
          <div
            className={`d-flex flex-column align-items-center ${
              step >= 2 ? "text-primary" : "text-muted"
            }`}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center mb-2 fw-bold"
              style={{
                width: "50px",
                height: "50px",
                background:
                  step >= 2
                    ? "linear-gradient(135deg, #667eea, #764ba2)"
                    : "#e9ecef",
                color: step >= 2 ? "white" : "#6c757d",
                fontSize: "1.2rem",
              }}
            >
              {step > 2 ? <i className="bi bi-check-lg"></i> : "2"}
            </div>
            <span className="small fw-semibold">Vị trí</span>
          </div>
          <div
            style={{
              width: "80px",
              height: "2px",
              background: step >= 3 ? "#667eea" : "#dee2e6",
              margin: "0 10px 30px",
            }}
          ></div>
          <div
            className={`d-flex flex-column align-items-center ${
              step >= 3 ? "text-primary" : "text-muted"
            }`}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center mb-2 fw-bold"
              style={{
                width: "50px",
                height: "50px",
                background:
                  step >= 3
                    ? "linear-gradient(135deg, #667eea, #764ba2)"
                    : "#e9ecef",
                color: step >= 3 ? "white" : "#6c757d",
                fontSize: "1.2rem",
              }}
            >
              3
            </div>
            <span className="small fw-semibold">Xác nhận</span>
          </div>
        </div>

        {/* Step Content */}
        <div className="mb-4">
          {step === 1 && renderStep1()}
          {step === 2 && renderStep2()}
          {step === 3 && renderStep3()}
        </div>

        {/* Navigation Buttons */}
        <div className="d-flex justify-content-between mt-4">
          <Button
            variant="light"
            disabled={step === 1}
            onClick={handleBack}
            className="px-4 py-2 rounded-3 shadow-sm fw-semibold"
            style={{
              visibility: step === 1 ? "hidden" : "visible",
            }}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Quay lại
          </Button>
          {step < 3 ? (
            <Button
              onClick={handleNext}
              className="px-4 py-2 rounded-3 shadow-sm fw-semibold border-0"
              style={{
                background: "linear-gradient(135deg, #667eea, #764ba2)",
                color: "white",
              }}
            >
              Tiếp theo
              <i className="bi bi-arrow-right ms-2"></i>
            </Button>
          ) : (
            <Button
              type="submit"
              form="bookingForm"
              disabled={isSubmitting}
              className="px-5 py-2 rounded-3 shadow-sm fw-semibold border-0"
              style={{
                background: isSubmitting
                  ? "#6c757d"
                  : "linear-gradient(135deg, #28c76f, #48da89)",
                color: "white",
                minWidth: "180px",
              }}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Đang xử lý...
                </>
              ) : (
                <>
                  <i className="bi bi-check-circle me-2"></i>
                  Xác nhận đặt chỗ
                </>
              )}
            </Button>
          )}
        </div>
      </Container>

      {/* Success Modal */}
      {showSuccess && (
        <div
          className="position-fixed top-50 start-50 translate-middle"
          style={{
            zIndex: 9999,
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          <div
            className="bg-white rounded-4 shadow-lg p-5 text-center"
            style={{ minWidth: "400px" }}
          >
            <div
              className="rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
              style={{
                width: "80px",
                height: "80px",
                background: "linear-gradient(135deg, #28c76f, #48da89)",
                animation: "scaleIn 0.5s ease-in-out",
              }}
            >
              <i
                className="bi bi-check-lg text-white"
                style={{ fontSize: "3rem" }}
              ></i>
            </div>
            <h3 className="fw-bold mb-3 text-success">Đặt bàn thành công!</h3>
            <p className="text-muted mb-2">Mã booking của bạn:</p>
            <h4 className="fw-bold text-primary">
              #
              {Math.floor(Math.random() * 10000)
                .toString()
                .padStart(4, "0")}
            </h4>
            <p className="text-muted mt-3 small">
              <i className="bi bi-envelope me-2"></i>
              Thông tin chi tiết đã được gửi qua email
            </p>
          </div>
          <div
            className="position-fixed top-0 start-0 w-100 h-100 bg-dark opacity-50"
            style={{ zIndex: -1 }}
          ></div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translate(-50%, -60%); }
          to { opacity: 1; transform: translate(-50%, -50%); }
        }
        @keyframes scaleIn {
          0% { transform: scale(0); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        .fade-in-animation {
          animation: fadeIn 0.3s ease-in-out;
        }
      `}</style>
    </div>
  );
}

export default Booking;
